module.exports = __webpack_public_path__ + "static/le-c-collectif-creatif-climat-0b5526d4d1c6f6a7a29f4b2e9b8f2db2.png";